export const FormContainer = ({className, children}) => {
    return (
        <div className={`bg-white p-5 rounded-lg shadow-md ${className}`}>
            {children}
        </div>
    );
};
